import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../../SvgIcons/CreateIconComponent';

export type HomeHeartIconProps = CreateIconComponentProps;
export const HomeHeartIcon: React.FC<HomeHeartIconProps> = ({
  title = 'HomeHeart',
  viewBox = '0 0 24 24',
  ...rest
}) => (
  <CreateIconComponent title={title} viewBox={viewBox} {...rest} fill="none">
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M5 12H3l9-9 9 9h-2M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-7"
    />
    <path
      fill="currentColor"
      d="M15.809 15.404a1 1 0 0 0-1.408-1.421l1.408 1.42Zm-3.931 2.485-.704.71a1 1 0 0 0 1.408 0l-.704-.71Zm-2.523-3.906a1 1 0 1 0-1.408 1.42l1.408-1.42ZM7.954 15.41a1 1 0 0 0 1.394-1.434L7.954 15.41Zm3.924-3.542-.803.597a1 1 0 0 0 1.602.004l-.8-.6Zm2.526 2.114a1 1 0 0 0 1.402 1.427l-1.402-1.427Zm-.003 0-3.227 3.197 1.408 1.42 3.226-3.195-1.407-1.421Zm-1.82 3.197-3.226-3.196-1.408 1.42 3.227 3.196 1.408-1.42Zm-3.233-3.203a1.151 1.151 0 0 1-.296-1.167l-1.91-.593a3.151 3.151 0 0 0 .812 3.194l1.394-1.434Zm-.296-1.167c.129-.413.479-.72.906-.793l-.336-1.971a3.151 3.151 0 0 0-2.48 2.17l1.91.595Zm.906-.793c.427-.072.859.1 1.117.449l1.606-1.194a3.151 3.151 0 0 0-3.06-1.226l.337 1.971Zm2.72.453c.259-.345.69-.516 1.115-.443l.34-1.97a3.151 3.151 0 0 0-3.054 1.211l1.598 1.202Zm1.115-.443c.426.074.775.38.903.792l1.91-.596a3.151 3.151 0 0 0-2.472-2.166l-.34 1.97Zm.903.792c.129.412.016.862-.292 1.164l1.402 1.427a3.151 3.151 0 0 0 .8-3.188l-1.91.597Z"
    />
  </CreateIconComponent>
);
